import { render } from "./leftLine.vue?vue&type=template&id=84472d08"
import script from "./leftLine.vue?vue&type=script&lang=js"
export * from "./leftLine.vue?vue&type=script&lang=js"
script.render = render

export default script